import { apiFetch } from "../Utility/api";

export const getNowLocalDateTime = () => {
  const now = new Date();
  const timezoneOffset = now.getTimezoneOffset() * 60000;
  return new Date(now.getTime() - timezoneOffset).toISOString().slice(0, 16);
};

export const eventCategoryLabels = {
  diaper: "Diaper",
  feeding: "Feeding",
  sleep: "Sleep",
};

export const eventCategoryPluralLabels = {
  diaper: "Diapers",
  feeding: "Feedings",
  sleep: "Sleep",
};

export const diaperTypes = ["Wet", "Dirty", "Mixed", "Dry/Checked"];
export const feedingTypes = ["Breast", "Bottle"];
export const bottleMilkTypes = ["Formula", "Breast Milk"];
export const sleepTypes = ["Sleep", "Wake Up"];
export const feedingSides = ["", "Left", "Right"];

export const feedingUnitForType = (eventType) => (eventType === "Breast" ? "min" : "oz");
export const normalizeFeedingType = (eventType) => (
  eventType === "Bottle Formula" || eventType === "Bottle Milk" ? "Bottle" : eventType
);

export const bottleMilkTypeForEvent = (event) => {
  if (event?.feedingMilkType) return event.feedingMilkType;
  if (event?.eventType === "Bottle Milk") return "Breast Milk";
  if (event?.eventType === "Bottle Formula") return "Formula";
  return "Formula";
};

export const sleepEventDisplay = (eventType) => {
  if (eventType === "Wake Up") {
    return {
      label: "Woke up",
      detail: "Wake time",
      tone: "wake",
    };
  }
  return {
    label: "Sleep started",
    detail: "Sleep time",
    tone: "sleep",
  };
};

export const defaultBabyEventForm = (category = "diaper", type = "Wet") => ({
  eventCategory: category,
  eventType: type,
  occurredAt: getNowLocalDateTime(),
  endedAt: "",
  feedingAmount: "",
  feedingUnit: feedingUnitForType(type),
  feedingMilkType: type === "Bottle" ? "Formula" : "",
  feedingSide: "",
  notes: "",
});

export const eventTypeOptionsForCategory = (category) => {
  if (category === "feeding") return feedingTypes;
  if (category === "sleep") return sleepTypes;
  return diaperTypes;
};

export const fetchBabySummary = async () => {
  const response = await apiFetch("/baby-tracker/summary");
  return response.json();
};

export const fetchBabyEvents = async (category = "") => {
  const categoryParam = category ? `?category=${encodeURIComponent(category)}` : "";
  const response = await apiFetch(`/baby-tracker/events${categoryParam}`);
  return response.json();
};

export const saveBabyEvent = async (eventForm, editingId = null) => {
  const response = await apiFetch(
    editingId ? `/baby-tracker/events/${editingId}` : "/baby-tracker/events",
    {
      method: editingId ? "PUT" : "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(eventForm),
    }
  );
  return response.json();
};

export const deleteBabyEvent = async (eventId) => {
  const response = await apiFetch(`/baby-tracker/events/${eventId}`, {
    method: "DELETE",
  });
  return response.json();
};
